export enum IDMappingType {
    None = "None",
    CustomFirst = "CustomFirst",
    CustomFirstHash = "CustomFirstHash",
    URL = "URL",
    ResourceID = "ResourceID"
}